var map = {
	"./QR.svg": "wNok",
	"./approval_mange.svg": "BS51",
	"./approval_mange_active.svg": "kI4N",
	"./carManage.svg": "DF+5",
	"./carManage_active.svg": "4pDQ",
	"./car_to_lease.svg": "CjfV",
	"./car_to_lease_active.svg": "q+Z1",
	"./checkRightHorn.svg": "5oyS",
	"./check_indeterminate.svg": "FBsG",
	"./checked.svg": "IzEa",
	"./circle-mark.svg": "cfck",
	"./company_new.svg": "7g1p",
	"./company_new_active.svg": "+WQQ",
	"./contract.svg": "7us4",
	"./contract_active.svg": "IYzN",
	"./customer.svg": "sX83",
	"./customer_active.svg": "aHbr",
	"./dashboard.svg": "94Jb",
	"./dashboard_active.svg": "KOzq",
	"./driver.svg": "6Fxs",
	"./driver_active.svg": "8Tz5",
	"./eye.svg": "TfVu",
	"./finance.svg": "tZnd",
	"./finance_active.svg": "hvEg",
	"./form.svg": "6xvN",
	"./hastenDebt.svg": "Yw2i",
	"./hastenDebt_active.svg": "Moq0",
	"./link.svg": "GPBF",
	"./logCenter.svg": "Suh1",
	"./logCenter_active.svg": "PC5N",
	"./message.svg": "R/8a",
	"./organization.svg": "4aEQ",
	"./organization_active.svg": "8S4j",
	"./password.svg": "Kj24",
	"./purchase_new.svg": "52hq",
	"./purchase_new_active.svg": "GcKl",
	"./return_lease.svg": "kdjU",
	"./return_lease_active.svg": "taLa",
	"./riskControl.svg": "cj/t",
	"./riskControl_active.svg": "v+JA",
	"./send email.svg": "fc27",
	"./service.svg": "TgQf",
	"./service_active.svg": "fep9",
	"./tenant_new.svg": "Lt64",
	"./tenant_new_active.svg": "hzJk",
	"./todo-count.svg": "wFnW",
	"./unchecked.svg": "lChH",
	"./under_lease.svg": "H5Ph",
	"./under_lease_active.svg": "ySgY",
	"./user-menu.svg": "+tLr",
	"./user-new.svg": "/6k8",
	"./user.svg": "s7Vf",
	"./vehicle.svg": "UsU7",
	"./vehicle_active.svg": "J/lI",
	"./workbench.svg": "k0PU",
	"./workbench_active.svg": "OlD9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";